import React, { useState, useEffect, useRef } from 'react';
import SingleListItem from './listitem';

interface ListItemProps {
  items: string[];
}

const StringListedItems: React.FC<ListItemProps> = ({ items }) => {
  const [isHovered, setIsHovered] = useState(false);
  const [maxWidth, setMaxWidth] = useState(0);
  const canvasRef = useRef<HTMLCanvasElement>(document.createElement('canvas'));
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const context = canvasRef.current.getContext('2d');
    if (context) {
      context.font = '16px Open Sans'; 
      const widths = items.map(item => context.measureText(item).width);
      setMaxWidth(Math.max(...widths));
    }
  }, [items]);

  return (
    <div
      ref={containerRef}
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative',
        cursor: 'pointer'
      }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <div>
        Assigned Roles
      </div>
      {isHovered && containerRef.current && (
        <div
          style={{
            position: 'absolute',
            top: `${containerRef.current.offsetHeight}px`, // Position below the hovered item
            left: `-${maxWidth }px`, // Shift the div to the left
            width: `${maxWidth + 20}px`, 
            height: 'auto',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            borderRadius: '0.75em',
            color: 'rgb(18, 40, 76)',
            flexDirection: 'column',
            backgroundColor: 'rgb(240, 242, 245)',
            boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
            zIndex: 10, // Higher z-index to ensure it pops out
             transform: 'translateZ(0)' 

          }}
        >
          {items.map((item, index) => (
            <SingleListItem key={index} Item={item} />
          ))}
        </div>
      )}
    </div>
  );
};

export default StringListedItems;



